import { useMutation } from 'react-query';
import axios from 'axios';

import { useAppSelector } from '@/app/hooks';
import { CreateSegmentDetails } from '@/models/Segments';
import { useAuth } from '@/modules/Auth/hooks/useAuth';
import { selectCurrentWorkspace } from '@/modules/Dashboard/Workspaces/workspaceSlice';
import { AwsConfigApiGateway } from '@/utils/config/api';

async function createSegment(data: CreateSegmentDetails, token: string | undefined, workspaceId: string) {
  const response = await axios.post<CreateSegmentDetails>(
    `${AwsConfigApiGateway.pooledTenantApiUrl}/workspaces/${workspaceId}/segments`,
    data,
    {
      headers: {
        'x-api-key': AwsConfigApiGateway.pooledTenantApiKey,
        Authorization: 'Bearer ' + token,
      },
    },
  );
  return response.data;
}

export function useCreateSegment() {
  const { user } = useAuth();
  const workspace = useAppSelector(selectCurrentWorkspace);
  return useMutation<CreateSegmentDetails, Error, CreateSegmentDetails>((data) =>
    createSegment(data, user?.signInUserSession.idToken.jwtToken, workspace?.id ?? ''),
  );
}
